<template>

    <div>
        <v-container fluid class="pa-0">
            <v-row dense>
                <v-col cols="12">

                    <slot></slot>

                </v-col>
            </v-row>
        </v-container>

        <v-btn v-show="nextButtonEnabled"
                :color="getRgbaColor(buttonColor)"
               :dark="isDarkColor(buttonColor)"
               right
               :loading="saving"
               tabindex="99"
               @click="nextClicked">
            {{ nextButtonText }}
            <v-icon>mdi-chevron-right</v-icon>
        </v-btn>

        <v-btn v-show="backButtonEnabled"
               :dark="isDarkColor(backgroundColor)"
               left
               text
               tabindex="-1"
               @click="backClicked">
            {{ backButtonText }}
        </v-btn>

        <v-btn v-show="!required"
               text
               tabindex="-1"
               :dark="isDarkColor(backgroundColor)"
               @click="skipClicked">
            {{ skipButtonText }}
        </v-btn>

    </div>

</template>

<script>

import colorMixin from "./colorMixin";

export default {

    name: "QuestionBase",

    mixins: [colorMixin],

    props: {

        buttonColor: {
            type: String,
            required: true,
        },

        backgroundColor: {
            type: String,
            required: true,
        },

        required: {
            type: Boolean,
            required: false,
            default: null,
        },

        nextButtonText: {
            type: String,
            required: true,
            default: 'Next',
        },

        nextButtonEnabled: {
            type: Boolean,
            required: false,
            default: true,
        },

        backButtonText: {
            type: String,
            required: false,
            default: 'Previous'
        },

        backButtonEnabled: {
            type: Boolean,
            required: false,
            default: false,
        },

        skipButtonText: {
            type: String,
            required: false,
            default: 'Skip'
        },

        saving: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    methods: {
        nextClicked() {
            this.$emit('next');
        },

        skipClicked() {
            this.$emit('skip');
        },

        backClicked() {
            this.$emit('back')
        }
    }
}
</script>
